<template>
	<footer class="pt-[32px] bg-[#F9F8F8]">
		<!-- 顶部栏：Logo  + 多语言 -->
		<div class="flex justify-between items-center title ml-[12.5vw] mr-[12.5vw]">
			<!-- Logo -->
			<div class="flex items-center">
				<router-link to="/mall/home">
					<img :src="footer_logo" alt="MM Flower" class="h-8" />
				</router-link>
				<el-divider direction="vertical" class="mx-6" />
				<img :src="footer_company" alt="MM Flower" class="h-6" />
			</div>
			<!-- 多语言选择 -->
			<setlang-select></setlang-select>
		</div>

		<!-- 主体三栏布局 -->
		<div class="grid grid-cols-3 gap-8 mb-8 pl-[12.5vw] pr-[12.5vw]">
			<!-- 左侧：功能导航 -->
			<div>
				<h3 class="font-bold text-[#0D0421] mb-6">{{ $t('uChoicePc.navtitle') }}</h3>
				<ul>
					<li class="cursor-pointer nav-item" @click="() => router.push({ path: '/mall/home' })">
						{{ $t('uChoicePc.home') }}
					</li>

					<li v-for="item in navItems" :key="item.path" class="cursor-pointer nav-item" @click="gotoNav(item)">
						{{ item.langKey ? $t(item.langKey) : item.name?.value }}
					</li>
				</ul>
			</div>

			<!-- 中间：联系我们 -->
			<div>
				<h3 class="font-bold text-[#0D0421] mb-6">{{ $t('uChoicePc.contantMe') }}</h3>
				<div class="text-sm text-[#6D6A75] contact-box">
					<p>{{ $t('uChoicePc.phone') }}：{{ contactInfo.phone }}</p>
					<p>{{ $t('uChoicePc.navemail') }}：{{ contactInfo.email }}</p>
					<p>{{ $t('uChoicePc.businessHours') }}：{{ $t('uChoicePc.defaultBusinessHours') }}</p>
					<p>{{ $t('uChoicePc.address') }}：{{ $t('uChoicePc.defaultCompanyAddress') }}</p>
				</div>
			</div>

			<!-- 右侧：二维码 -->
			<div class="flex justify-end gap-[24px]">
				<div class="flex flex-col items-center" v-for="qrcode in qrcodeList" :key="qrcode.type">
					<div class="w-24 h-24 mb-1 bg-white rounded-4px flex items-center justify-center">
						<img :src="qrcode.qrcodeUrl" alt="qrcode" class="w-24 h-24 object-contain" />
					</div>
					<span class="text-[14px] text-[#0D0421]">{{ qrcode.account }}</span>
				</div>
			</div>
		</div>

		<!-- 底部版权栏 -->
		<div class="bg-[#000000] text-white rounded-b-xl py-4 text-center text-xs">
			{{ $t('uChoicePc.defaultCopyright') }}
		</div>
	</footer>
</template>

<script setup lang="ts">
import { ref, toRef, type PropType } from 'vue'
import setlangSelect from './setLangSelect.vue'
import { useRouter } from 'vue-router'

const router = useRouter()
// 定义类型，严格匹配设计稿字段
type ContactInfo = {
	phone: string
	email: string
}

type QrcodeItem = {
	type: 'whatsapp' | 'telegram'
	label: string
	account: string
	qrcodeUrl: string
}

const footer_logo = new URL('@/assets/img/footer_logo.png', import.meta.url).href
const footer_company = new URL('@/assets/img/footer-icon.png', import.meta.url).href
// 导航列表（严格匹配设计稿顺序）

interface NavItem {
	id: string
	name: { value: string }
	path: string
	child?: any[]
	langKey?: string
}

const props = defineProps({
	navItems: {
		type: Array as PropType<NavItem[]>,
		default: () => [] as NavItem[]
	}
})

const navItems = toRef(props, 'navItems')
const gotoNav = (item: any) => {
	if (item.path === '/mall/category/') {
		router.push({
			path: '/mall/category/' + item.id,
			query: {
				id: item.id,
				name: item.name?.value
			}
		})
	} else {
		router.push({
			path: '/mall/about',
			query: {}
		})
	}
}
// 联系信息（默认值匹配设计稿）
const contactInfo = ref<ContactInfo>({
	phone: '+86 15988291982',
	email: 'info@flowerstore.com'
})

// 二维码信息（匹配设计稿）
const qrcodeList = ref<QrcodeItem[]>([
	{
		type: 'whatsapp',
		account: 'Scan WhatsApp QR Code',
		qrcodeUrl: new URL('@/assets/img/WhatsApp.png', import.meta.url).href // 替换为实际二维码地址
	},
	{
		type: 'WeChat',
		account: 'Scan WeChat QR Code',
		qrcodeUrl: new URL('@/assets/img/WeChat.png', import.meta.url).href // 替换为实际二维码地址
	}
])
</script>

<style scoped lang="scss">
.title {
	margin-bottom: 32px;
	padding-bottom: 32px;
	border-bottom: 1px solid #dfdfdf;
}
.nav-item {
	margin-bottom: 16px;
	&:last-child {
		margin-bottom: 0;
	}
	&:hover {
		font-weight: 600;
	}
}
.contact-box {
	p {
		margin-bottom: 20px;
	}
}
</style>
